// We need to use the Stripe publishable key to initialize Stripe.js, it is safe to expose these keys in the frontend.
export const PPL_STRIPE_PUBLISHABLE_PROD_KEY = 'pk_live_51N9YqBGZwjqPfxkZtUgmBVuQH2100lzQ2yLYZp7mlr80eUyO8n3fBwXMgeMIhARze7BNrAHjhOXRD1u5AawwCO8800sFI1FBVA';
export const PPL_STRIPE_PUBLISHABLE_TEST_KEY = 'pk_test_51TLmw2K0KLr8FIgWPSzctUbz5dIj1qYELv4Li6vSSdtJDmmVxK24C7Qz5NKy8qjEyCDbnPcdLU5kPp3eza4iiUVq00VsFW8rO1';
export const PPL_STRIPE_PUBLISHABLE_LOCAL_KEY = 'pk_test_51TABRuKGTLXVmU1bUvlgAZirLnvSz4j6Nge2SuzAzZTibj6Q1aDZaFDM3AQfa1XFRYtBQ8TD90zYCX1XBXCmGpZZ00QxWcUiGJ';
export const getStripePublishableKey = ({ isLocalhost, isProduction, isStaging, }) => {
    if (isProduction || isStaging) {
        return PPL_STRIPE_PUBLISHABLE_PROD_KEY;
    }
    if (isLocalhost) {
        return PPL_STRIPE_PUBLISHABLE_LOCAL_KEY;
    }
    return PPL_STRIPE_PUBLISHABLE_TEST_KEY;
};
//# sourceMappingURL=stripeKeys.js.map